import * as React from "react";
import { Button, Dropdown, MenuItem } from "react-ui";

import { arrayHasLength } from "../../../../../../Common/TypingUtils";

export interface PageAction {
    "data-tid"?: string;
    description: string;
    handler: (instancePath?: string) => void;
    disabled: boolean;
}

interface PageActionsProps {
    actions: PageAction[];
    disabled: boolean;
    caption: string;
    instancePath?: string;
}

export function PageActions(props: PageActionsProps): JSX.Element {
    if (arrayHasLength(props.actions, 1)) {
        const action = props.actions[0];
        return (
            <Button
                disabled={props.disabled}
                data-tid={action["data-tid"]}
                data-focus="noFocus"
                onClick={() => action.handler(props.instancePath)}>
                {action.description}
            </Button>
        );
    }

    return (
        <Dropdown data-focus="noFocus" caption={props.caption} disabled={props.disabled}>
            {props.actions.map(action => (
                <MenuItem
                    key={action.description}
                    data-tid={action["data-tid"]}
                    onClick={() => action.handler(props.instancePath)}
                    disabled={action.disabled}>
                    {action.description}
                </MenuItem>
            ))}
        </Dropdown>
    );
}
